import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  Print as PrintIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
} from '@mui/icons-material';

const A4PreviewDialog = ({ open, onClose, htmlContent, onPrint, container, style }) => {
  const [zoom, setZoom] = React.useState(1);

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.1, 2));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 0.1, 0.5));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      container={container}
      disablePortal={!!container}
      style={style}
      sx={{
        position: container ? 'absolute' : undefined,
        zIndex: container ? 2000 : undefined,
      }}
      BackdropProps={{
        sx: {
          position: container ? 'absolute' : undefined,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Preview Invoice (A4)
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <IconButton onClick={handleZoomOut} size="small" title="Zoom Out">
            <ZoomOutIcon />
          </IconButton>
          <Typography variant="body2" sx={{ minWidth: 50, textAlign: 'center' }}>
            {Math.round(zoom * 100)}%
          </Typography>
          <IconButton onClick={handleZoomIn} size="small" title="Zoom In">
            <ZoomInIcon />
          </IconButton>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0, bgcolor: '#525659', overflow: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            p: 3,
            minHeight: '100%',
          }}
        >
          <Box
            sx={{
              width: '210mm',
              minHeight: '297mm',
              bgcolor: 'white',
              boxShadow: '0 0 20px rgba(0,0,0,0.3)',
              transform: `scale(${zoom})`,
              transformOrigin: 'top center',
              transition: 'transform 0.2s',
            }}
          >
            <iframe
              srcDoc={htmlContent}
              style={{
                width: '100%',
                height: '297mm',
                border: 'none',
              }}
              title="A4 Invoice Preview"
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button onClick={onClose} variant="outlined" sx={{ minWidth: 100 }}>
          Close
        </Button>
        <Button
          onClick={onPrint}
          variant="contained"
          startIcon={<PrintIcon />}
          sx={{ minWidth: 120 }}
        >
          Print Invoice
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default A4PreviewDialog;